import {BusyStatus} from "../BusyStatus";
import {Card} from "react-bootstrap";

export default function Step({index, title, children, canProceed, isFinal, busyReason}) {
  return <div className={"container"}>
    <div className={"row gx-5 mt-4 align-items-stretch"}>
      <WelcomeCard/>
      <Card className={"col-8 ps-2"}>
        <Card.Header>
          <h3>Step {index}: {title}</h3>
        </Card.Header>
        <Card.Body>
          {children}
        </Card.Body>
        <Card.Footer className={"d-flex align-items-baseline justify-content-end"}>
          {canProceed && !!!isFinal && (
            <a href={"/welcome/" + (index + 1)} className={"btn btn-primary"}>
              Next
            </a>
          )}
          {canProceed && isFinal && (
            <a href={"/"} className={"btn btn-primary"}>
              Start Using Prosperity
            </a>
          )}
          {!canProceed && (
            <>
            <span className={"text-muted me-2"}>
              {busyReason}
            </span>
              <a href="#" className={"btn btn-primary disabled"}>
                Next
              </a>
            </>
          )}
        </Card.Footer>
      </Card>
    </div>
  </div>
}

function WelcomeCard() {
  return <Card className={"col-4"}>
    <Card.Header>
      <h3>Welcome to Prosperity.</h3>
    </Card.Header>
    <Card.Body>
      <p>
        Get a handle on how you spend your money.
      </p>
      <p>
        It will take a few minutes to download your transaction history
        and use Artificial Intelligence to categorize your transactions.
      </p>
      <p>
        Meanwhile, you can start getting things set up, and learn about
        how to use Prosperity.
      </p>
    </Card.Body>
    <Card.Footer>
      <BusyStatus/>
    </Card.Footer>
  </Card>
}
